module.exports = __webpack_public_path__ + "img/ring_y_e_null_0@3x.fb9ee182.png";